import { render, staticRenderFns } from "./EvidenciaBHP.vue?vue&type=template&id=5ab8c5f6&scoped=true&"
import script from "./EvidenciaBHP.vue?vue&type=script&lang=ts&"
export * from "./EvidenciaBHP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab8c5f6",
  null
  
)

export default component.exports